
import React from 'react';

export const ServicesSection: React.FC = () => {
  const services = [
    {
      icon: 'ri-shield-check-line',
      title: 'İş Güvenliği Uzmanı Hizmeti',
      description: 'Tehlike sınıfınıza uygun planlanan periyotlarla saha denetimleri, İSG Kurulu çalışmaları, uygunsuzluk tespiti ve aksiyon takibi yapılır.',
      color: 'bg-blue-500'
    },
    {
      icon: 'ri-stethoscope-line',
      title: 'İşyeri Hekimi Hizmeti',
      description: 'Çalışan periyodik muayeneleri, sağlık taramaları, işe giriş sağlık raporları ve sağlık kayıt sistematiği yürütülür.',
      color: 'bg-green-500'
    },
    {
      icon: 'ri-team-line',
      title: 'Diğer Sağlık Personeli (DSP)',
      description: 'İşyeri hekiminin planlamalarına uygun saha desteği, çalışan sağlık kayıtlarının güncellenmesi ve İSG süreçlerinin takibi sağlanır.',
      color: 'bg-purple-500'
    },
    {
      icon: 'ri-file-search-line',
      title: 'Risk Analizi',
      description: 'İşyerindeki tehlikeler belirlenir, risk seviyesi değerlendirilir ve kontrol tedbirleri planlanır.',
      color: 'bg-red-500'
    },
    {
      icon: 'ri-alarm-warning-line',
      title: 'Acil Eylem Planları',
      description: 'Yangın, deprem, kimyasal sızıntı gibi acil durumlar için detaylı eylem planları hazırlanır ve tatbikatlar düzenlenir.',
      color: 'bg-orange-500'
    },
    {
      icon: 'ri-graduation-cap-line',
      title: 'İSG Eğitimleri',
      description: 'Temel İSG, yüksekte çalışma, yangın ve acil durum, KKD kullanımı ve işe yeni başlayan eğitimleri.',
      color: 'bg-indigo-500'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4"> Hizmetlerimiz</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            İşyerlerinde güvenli ve sağlıklı çalışma ortamı oluşturmak için kapsamlı İş Sağlığı ve Güvenliği hizmetleri sunuyoruz.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow duration-300">
              <div className={`w-16 h-16 ${service.color} rounded-lg flex items-center justify-center mb-6`}>
                <i className={`${service.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{service.title}</h3>
              <p className="text-gray-600 leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
